"use client";

import "@/components/bloks/defineBloks";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { CentraProvider } from "@trydig/centra/client";
import { StoryblokProvider } from "@trydig/storyblok";
import { NextUIProvider } from "@trydig/ui/next";
import { Provider } from "jotai";
import { useRouter } from "next/navigation";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import type React from "react";
import { useState } from "react";
import { env } from "@/env.mjs";
import DeviceProvider from "@/features/device/DeviceProvider";
import { DepictTracking } from "@/features/global/DepictTracking";

interface Props {
	children: React.ReactNode;
}

export const Providers = ({ children }: Props) => {
	const router = useRouter();
	const [queryClient] = useState(() => new QueryClient());

	const handlePublish = () => {
		router.refresh();
	};

	return (
		<NuqsAdapter>
			<NextUIProvider>
				<DeviceProvider>
					<QueryClientProvider client={queryClient}>
						<StoryblokProvider onPublished={handlePublish}>
							<CentraProvider apiUrl={env.NEXT_PUBLIC_CENTRA_CHECKOUT}>
								<DepictTracking />
								<Provider>{children}</Provider>
								<ReactQueryDevtools />
							</CentraProvider>
						</StoryblokProvider>
					</QueryClientProvider>
				</DeviceProvider>
			</NextUIProvider>
		</NuqsAdapter>
	);
};
